module.exports = __webpack_public_path__ + "media/images/badges/cyclebar/red/RideClub_Milestones_App_25-Red-6ca3f68413b088f500eb1863d2f6d593.png";